module.exports = __webpack_public_path__ + "static/media/plus.2f2bf5b3.svg";